import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  CalendarFilterSetAll,
  CalendarFilterReset
} from '../calendar-filter/actions';
import {
  CalendarActionTypes,
  LoadCalendarSuccess,
  LoadCalendarFail,
  LoadCalendar,
  UpdateDeals,
  UpdateDealsSuccess,
  UpdateDealsFail,
  SetSavedFilter
} from './actions';
import { SharedState, selectCalendarWeekOf } from '../reducer';
import { CalendarService } from '../../services/calendar.service';

@Injectable()
export class CalendarEffects {
  
  public loadDeals$: Observable<
    LoadCalendarSuccess | LoadCalendarFail
  > = createEffect(() => this.actions$.pipe(
    ofType(CalendarActionTypes.LoadCalendar),
    withLatestFrom(this.store.pipe(select(selectCalendarWeekOf))),
    switchMap(([, weekOf]) =>
      this.calendarService.getDeals(weekOf).pipe(
        map((deals: any) => new LoadCalendarSuccess(deals)),
        catchError((error) =>
          of(new LoadCalendarFail(error && (error as Error).message))
        )
      )
    )
  ));

  
  public updateDeals$: Observable<
    UpdateDealsSuccess | UpdateDealsFail
  > = createEffect(() => this.actions$.pipe(
    ofType(CalendarActionTypes.UpdateDeals),
    switchMap((action: UpdateDeals) =>
      this.calendarService.getDealsById(action.payload).pipe(
        map(
          (deals: any) => new UpdateDealsSuccess(deals),
          catchError((err) => of(new UpdateDealsFail(err)))
        )
      )
    )
  ));

  
  public updateWeekOf$: Observable<LoadCalendar> = createEffect(() => this.actions$.pipe(
    ofType(CalendarActionTypes.UpdateWeekOf),
    map(() => new LoadCalendar())
  ));

  
  public setSavedFilterSet$: Observable<
    CalendarFilterSetAll | CalendarFilterReset
  > = createEffect(() => this.actions$.pipe(
    ofType(CalendarActionTypes.SetSavedFilter),
    map((action: SetSavedFilter) => {
      if (action.payload) {
        return new CalendarFilterSetAll(action.payload.filterSet);
      } else {
        return new CalendarFilterReset();
      }
    })
  ));

  constructor(
    public calendarService: CalendarService,
    private actions$: Actions,
    private store: Store<SharedState>
  ) {}
}
